import React from 'react';
import './TableRowWrapper.scss';

interface IProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const TableRowWrapper = React.forwardRef<HTMLTableRowElement, IProps>((props, ref) => {
  const {children, disabled = false, style = {}, className = '', ...rest} = props;
  return (
    <tr
      data-testid="table-row-wrapper"
      ref={ref}
      {...rest}
      style={style}
      className={`${className} table-row-wrapper ${disabled ? 'table-row-wrapper--disabled' : ''}`}
    >
      {children}
    </tr>
  );
});

export default TableRowWrapper;
